// extracted by mini-css-extract-plugin
export default {"sort":"IT-z","sortSelect":"JT-z","disabled":"KT-z"};